<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Implement Display Order</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>
    <div class="ttmodal__body">
        <mat-selection-list  class="implementList" [(ngModel)]="implementIds">
            <a mat-list-item *ngFor="let item of filteredList;" >
          
              <h3 matLine> {{item.Name}}</h3>
              <button mat-icon-button (click)="down($event, item)">
                <mat-icon>arrow_downward</mat-icon>
              </button>
              <button mat-icon-button (click)="up($event, item)">
                  <mat-icon>arrow_upward</mat-icon>
                </button>
            
            </a>
          </mat-selection-list >
        
        
    </div>
    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" (click)="saveChanges()"><span class="button__text">Save</span></a>
    </div>
  </div>